/**
 * The loan an email or invite link is about, carried as `?loanNumber=` (PATH and Link APIs)
 * or `?LoanNumber=` (Snap). PATH has no loan-scoped route, so without this a borrower with
 * several loans follows a link about one and lands on whichever the switcher last held.
 *
 * Held in session storage because the link usually lands on /login, /register or
 * /claim-account and the loan list only loads after sign-in. The number is not a
 * credential: the list it is matched against is the borrower's own.
 */

import { searchThroughReturnUrl } from '@/lib/returnUrlSearch';

/** Exported so tests assert against the real key rather than mirroring a literal. */
export const LOAN_NUMBER_LINK_STORAGE_KEY = 'path_link_loan_number';

const PARAM = 'loannumber';

function readParam(params: URLSearchParams): string | null {
  for (const [key, value] of params) {
    if (key.toLowerCase() !== PARAM) continue;
    const trimmed = value.trim();
    if (trimmed) return trimmed;
  }
  return null;
}

export function loanNumberFromSearch(search: string | null | undefined): string | null {
  return searchThroughReturnUrl(search, readParam);
}

export function storeLinkedLoanNumber(loanNumber: string): void {
  try {
    sessionStorage.setItem(LOAN_NUMBER_LINK_STORAGE_KEY, loanNumber);
  } catch {
    /* storage unavailable */
  }
}

export function readLinkedLoanNumber(): string | null {
  try {
    return sessionStorage.getItem(LOAN_NUMBER_LINK_STORAGE_KEY);
  } catch {
    return null;
  }
}

/** Once applied or found not to be the borrower's, so a later visit restores their own choice. */
export function clearLinkedLoanNumber(): void {
  try {
    sessionStorage.removeItem(LOAN_NUMBER_LINK_STORAGE_KEY);
  } catch {
    /* storage unavailable */
  }
}
